export default "__VITE_ASSET__CEeJblEH__"